const _temp0 = require("../component-library/footer/footer-style.css");

const _temp1 = require("../component-library/form/feedback-form-style.css");
const _temp2 = require("../component-library/form/form-custom-select-style.css");
const _temp3 = require("../component-library/form/form-field-style.css");
const _temp4 = require("../component-library/form/form-group-style.css");
const _temp5 = require("../component-library/form/form-submit-button-style.css");
const _temp6 = require("../component-library/form/gform-style.css");

const _temp7 = require("../component-library/inline-svg/inline-svg-style.css");

const _temp8 = require("../component-library/media/media-style.css");

const _temp9 = require("../component-library/menu/menu-style.css");

const _temp10 = require("../component-library/slider/slider-style.css");

const _temp11 = require("../component-library/wp-overrides/wp-style.css");

module.exports = {
  "footer":   {
    "footer-": _temp0
  },
  "form":   {
    "feedback-form-": _temp1,
    "form-custom-select-": _temp2,
    "form-field-": _temp3,
    "form-group-": _temp4,
    "form-submit-button-": _temp5,
    "gform-": _temp6
  },
  "inline-svg":   {
    "inline-svg-": _temp7
  },
  "media":   {
    "media-": _temp8
  },
  "menu":   {
    "menu-": _temp9
  },
  "slider":   {
    "slider-": _temp10
  },
  "wp-overrides":   {
    "wp-": _temp11
  }
}